import { useNavigate } from '@tanstack/react-router';
import { Logo } from '@/components/atoms/Logo';
import { Button } from '@/components/ui/button';
import { APP_ROUTES } from '@/const/routes';

export const NotFoundPage = () => {
  const navigate = useNavigate();

  return (
    <div className="bg-primary min-h-screen flex flex-col text-primary-foreground">
      <Logo
        imageVariant="black"
        logoClassName="size-8 absolute top-4 left-4"
        showText={false}
      />
      
      <div className="flex-1 flex flex-col items-center justify-center gap-6 text-center px-4">
        <p className="text-7xl font-syne font-bold">404</p>
        <div className="space-y-2">
          <p className="text-2xl font-semibold">Oops! We can't find that one</p>
          <p className="text-primary-foreground/70 max-w-sm">
            Sorry, an unexpected error has occurred.
          </p>
        </div>
        <Button
          className="bg-foreground text-background hover:bg-foreground/90"
          onClick={() => navigate({ to: APP_ROUTES.index })}
        >
          Go to home page
        </Button>
      </div>
    </div>
  );
};
